<template>
    <HeaderContent title="Offer Document"/>
    <ActionContent ctaText="Offer Docs" @action="modal = !modal "/>
    <AdminStatistics title="Driver & Guide Statistics" :data="statistics" />
    <AdminDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>

</template>


<script>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import AdminDataTable from '@/components/DataTable.vue';
import AdminStatistics from '@/components/StatisticData.vue';
import offerDoc from '@/dummy-data/offerDoc.js';
// import iconLevel from '../../../public/icons/arrow-comparison.svg';
import iconUser from '../../../public/icons/users-alt.svg';
import { ref,} from 'vue';

export default{
    name : 'OfferDocIndex',
    components: {
        HeaderContent,
        ActionContent,
        AdminDataTable,
        AdminStatistics
    },
    setup(){
        const modal = ref(false)
        const statistics = ref([
            {
                label: 'Total',
                key: 'Offered',
                value: 3,
                color: 'info',
                icon: iconUser,
            },
            {
                label: 'Total',
                key: 'Accepted',
                value: 2,
                color: 'info',
                icon: iconUser,
            },
        ]);
        const headers = ref([
            {key : 'id',label: 'ID',sortable: true,},
            {key : 'status', label : 'Status',sortable: true,},
            {key : 'guest', label : 'Guest',sortable: true,},
            {key : 'email', label : 'Email',sortable: true,},
            {key : 'contact', label : 'Contact',sortable: true, },
            {key : 'pax', label : 'Pax',sortable: true,},
            {key : 'duration', label : 'Duration (Day)',sortable: true,},
            {key : 'arrival', label : 'Arrival',sortable: true,},
            {key : 'departure', label : 'Departure',sortable: true,},
            {key : 'price', label : 'Pice',sortable: true,},
            
            {key: 'action', label: 'Actions',}
        ])
        const customActions = ref([
        {
            label: ((item)=>item.status == 'Offered' ? 'Set Accepted' : 'Is Accepted'),
            icon: 'fas fa-check',
            variant: ((item)=>item.status == 'Accepted' ? 'secondary' : 'primary'),
            action: (item) => {

            console.log('Extra charge action clicked for:', item);
            // Implement your extra charge logic here
            }
        
        },
    
        {
            label: 'Edit',
            variant: 'success',
            icon: 'fas fa-edit',
            action: (item) => {
            console.log('Edit action clicked for:', item);
            // Implement your edit logic here
            }
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: 'fas fa-trash',
            action: (item) => {
            console.log('Delete action clicked for:', item);
            // Implement your delete logic here
            }
        },
    
    ])
    const data= offerDoc
    return{
        modal,statistics,headers,customActions,data
    }
     
    }
  
}

</script>


